import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a0b53c2e")

_pushScopeId("data-v-a0b53c2e")
const _hoisted_1 = { class: "p-grid" }
const _hoisted_2 = { class: "p-col-12" }
const _hoisted_3 = { class: "p-fluid p-m-2" }
const _hoisted_4 = { class: "p-grid" }
const _hoisted_5 = { class: "p-col-12 p-md-4 p-d-flex p-ai-center p-py-0 p-py-md-2" }
const _hoisted_6 = { class: "title p-mb-0 p-mr-2 p-text-nowrap" }
const _hoisted_7 = {
  class: "p-text-bold p-m-0",
  style: {"word-break":"break-word"}
}
const _hoisted_8 = { class: "p-col-12 p-md-4 p-d-flex p-ai-center p-py-0 p-py-md-2" }
const _hoisted_9 = { class: "title p-mb-0 p-mr-2" }
const _hoisted_10 = { class: "p-text-bold" }
const _hoisted_11 = { class: "p-col-12 p-md-4 p-d-flex p-ai-center p-py-0 p-py-md-2" }
const _hoisted_12 = { class: "title p-mb-0 p-mr-2" }
const _hoisted_13 = { class: "p-text-bold" }
const _hoisted_14 = { class: "p-col-12 p-md-4 p-d-flex p-ai-center p-py-0 p-py-md-2" }
const _hoisted_15 = { class: "title p-mb-0 p-mr-2" }
const _hoisted_16 = { class: "p-text-bold p-m-0" }
const _hoisted_17 = { class: "p-col-12 p-md-4 p-d-flex p-ai-center p-py-0 p-py-md-2" }
const _hoisted_18 = { class: "title p-mb-0 p-mr-2" }
const _hoisted_19 = { class: "p-text-bold p-m-0" }
const _hoisted_20 = { class: "p-col-12 p-md-4 p-d-flex p-ai-center p-py-0 p-py-md-2" }
const _hoisted_21 = { class: "title p-mb-0 p-mr-2" }
const _hoisted_22 = { class: "p-text-bold" }
const _hoisted_23 = { class: "detail-schema" }
const _hoisted_24 = { class: "p-d-flex p-ai-center" }
const _hoisted_25 = { class: "p-pl-2" }
const _hoisted_26 = { class: "p-d-flex p-ai-center" }
const _hoisted_27 = { class: "p-pl-2" }
const _hoisted_28 = {
  key: 0,
  class: "p-d-flex p-ai-center"
}
const _hoisted_29 = { class: "p-d-flex p-ai-center" }
const _hoisted_30 = { class: "p-pl-2" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DatasourceStatus = _resolveComponent("DatasourceStatus")!
  const _component_DatasourceFileList = _resolveComponent("DatasourceFileList")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataType = _resolveComponent("DataType")!
  const _component_DataRole = _resolveComponent("DataRole")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("h5", null, _toDisplayString(_ctx.$t("datasource.list-files.table.header.data_info")), 1),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("datasource.metadata.name")) + ": ", 1),
            _createVNode("p", _hoisted_7, _toDisplayString(_ctx.datasourceDetail?.name), 1)
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("datasource.metadata.created_by")) + ": ", 1),
            _createVNode("p", _hoisted_10, _toDisplayString(_ctx.getFullname(_ctx.datasourceDetail?.createdBy)), 1)
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode("p", _hoisted_12, _toDisplayString(_ctx.$t("datasource.metadata.created_date")) + ": ", 1),
            _createVNode("p", _hoisted_13, _toDisplayString(_ctx.$moment(_ctx.datasourceDetail?.createdDate).format(
                  "YYYY-MM-DD HH:mm:ss"
                )), 1)
          ]),
          _createVNode("div", _hoisted_14, [
            _createVNode("p", _hoisted_15, _toDisplayString(_ctx.$t("datasource.metadata.total_files")) + ": ", 1),
            _createVNode("p", _hoisted_16, _toDisplayString(_ctx.fileListLength) + " " + _toDisplayString(_ctx.$t("datasource.list-files.table.title")), 1)
          ]),
          _createVNode("div", _hoisted_17, [
            _createVNode("p", _hoisted_18, _toDisplayString(_ctx.$t("datasource.metadata.total_size")) + ": ", 1),
            _createVNode("p", _hoisted_19, _toDisplayString(_ctx.$humanFileSize(_ctx.totalSize)), 1)
          ]),
          _createVNode("div", _hoisted_20, [
            _createVNode("p", _hoisted_21, _toDisplayString(_ctx.$t("datasource.metadata.status")) + ": ", 1),
            _createVNode("p", _hoisted_22, [
              _createVNode(_component_DatasourceStatus, {
                status: _ctx.datasourceDetail?.status
              }, null, 8, ["status"])
            ])
          ])
        ])
      ]),
      _createVNode("div", null, [
        _createVNode("h5", null, _toDisplayString(_ctx.$t("datasource.list-files.table.header.files_list")), 1),
        _createVNode(_component_DatasourceFileList, {
          id: _ctx.fileListId,
          workspaceId: _ctx.workspaceId
        }, null, 8, ["id", "workspaceId"])
      ]),
      _createVNode("div", null, [
        _createVNode("h5", _hoisted_23, _toDisplayString(_ctx.$t("datasource.list-files.table.header.schemas")), 1),
        _createVNode(_component_DataTable, {
          responsiveLayout: "scroll",
          scrollHeight: "40vh",
          value: _ctx.datasourceDetail.schemas,
          class: "p-datatable-sm"
        }, {
          default: _withId(() => [
            _createVNode(_component_Column, null, {
              header: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("datasource.metadata.column_name")), 1)
              ]),
              body: _withId((slotProps) => [
                _createVNode("div", _hoisted_24, [
                  _createVNode("div", _hoisted_25, _toDisplayString(slotProps.data.name), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { style: {"min-width":"10rem"} }, {
              header: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("datasource.metadata.data_type")), 1)
              ]),
              body: _withId((slotProps) => [
                _createVNode("div", _hoisted_26, [
                  _createVNode(_component_DataType, {
                    dataType: slotProps.data.type
                  }, null, 8, ["dataType"]),
                  _createVNode("div", _hoisted_27, _toDisplayString(_ctx.$t(`datasource.datatype.${slotProps.data.type}`)), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { style: {"min-width":"10rem"} }, {
              header: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("datasource.metadata.data_role")), 1)
              ]),
              body: _withId((slotProps) => [
                (slotProps.data.role)
                  ? (_openBlock(), _createBlock("div", _hoisted_28, [
                      _createVNode(_component_DataRole, {
                        role: slotProps.data.role
                      }, null, 8, ["role"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { style: {"min-width":"10rem"} }, {
              header: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("datasource.metadata.format")), 1)
              ]),
              body: _withId((slotProps) => [
                _createVNode("div", _hoisted_29, [
                  _createVNode("div", _hoisted_30, _toDisplayString(slotProps.data.format), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ])
    ])
  ]))
})